import { render, staticRenderFns } from "./ElaborazioniBatchPage.vue?vue&type=template&id=4c7cd7a0"
import script from "./ElaborazioniBatchPage.vue?vue&type=script&lang=js"
export * from "./ElaborazioniBatchPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports